import React from 'react'
import { TextField, TextFieldProps } from '@mui/material'

export function CustomPhoneInput(props: TextFieldProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(/[^\d]/g, '').slice(0, 10)
    if (props.onChange) {
      e.target.value = val
      props.onChange(e)
    }
  }

  return (
    <TextField
      size="small"
      fullWidth
      {...props}
      inputProps={{ inputMode: 'numeric', maxLength: 10, ...props.inputProps }}
      onChange={handleChange}
    />
  )
}